module.exports = __webpack_public_path__ + "static/media/ma_100hasta200Banner.c2a83b3c.png";